import { useRef, useState } from "react";
import "./SetPassword.scss";
import { AuthModal } from "../index";
import { Field, Formik, Form } from "formik";
import {
  Button,
  Input,
  PasswordStrengthChecker,
  PasswordValidation,
} from "shared";
import * as Yup from "yup";
import { useSetSuccessorPassword } from "hooks/successors";
import { VALIDATION_ENUM } from "enums";

interface SetPasswordType {
  makeAccess: () => void;
}

const SetPassword = ({ makeAccess }: SetPasswordType) => {
  const [showValidation, setShowValidation] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState<
    "weak" | "medium" | "strong"
  >("weak");
  const formRef = useRef<any>(null);

  const { mutate } = useSetSuccessorPassword({
    onSuccess: () => {
      makeAccess();
    },
  });


  const validation = () =>
    Yup.object().shape({
      email: Yup.string()
        .email(VALIDATION_ENUM.WRONG_EMAIL)
        .required(VALIDATION_ENUM.REQUIRED)
        .matches(
          /^[a-zA-Z0-9_%+-]+([.][a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          VALIDATION_ENUM.WRONG_EMAIL
        ),
      password: Yup.string()
        .required("Pole wymagane")
        .min(8, "Minimum 8 znaków"),
    });

  const initialValues = {
    email: "",
    password: "",
  };

  const onSubmit = (values: typeof initialValues) => {
    const { email, password } = values;
    mutate({ email, password, passwordStrength });
  };

  return (
    <AuthModal
      heading={"Utwórz konto do zakładki „Sukcesja”"}
      paragraph={
        <>
          <p>
            Ze względów bezpieczeństwa dostęp do tej zakładki wymaga utworzenia
            dodatkowego konta. Podaj adres mailowy oraz utwórz hasło, którym
            będziesz się logować do Sukcesji.
          </p>
          <p>Na podany adres e-mail wyślemy jednorazowy kod weryfikacyjny.</p>
        </>
      }
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onSubmit(values)}
        validationSchema={validation()}
        innerRef={formRef}
      >
        {({ values, handleSubmit }) => (
          <Form>
            <Field
              type="text"
              id="email"
              name="email"
              label={"E-mail"}
              as={Input}
            />{" "}
            <Field
              type="password"
              id="password"
              name="password"
              label={"Hasło"}
              as={Input}
              onFocus={() => setShowValidation(true)}
              onBlur={() => isPasswordValid && setShowValidation(false)}
            />
            <PasswordStrengthChecker
              password={values.password}
              isHidden={!showValidation}
              onStrengthChange={(value) => setPasswordStrength(value)}
            />
            <PasswordValidation
              show={showValidation}
              password={values.password}
              setIsValid={(value: boolean) => setIsPasswordValid(value)}
            />
            <Button
              className="successor-auth-modal__button"
              label={"Potwierdź hasło"}
              styleType="primary"
              onClick={() => handleSubmit()}
            />
          </Form>
        )}
      </Formik>
    </AuthModal>
  );
};

export default SetPassword;
